import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {ProductState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class ProductQuery extends QueryEntity<ProductState> {

  constructor(protected store: Store) {
    super(store);
  }

}
